<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <!-- Start:: Image Ar -->
            <!-- <div class="col-lg-6">
              <uplode-image-direct
                @inputChanged="uplodeImg_1"
                :placeHolder="$t('forms.labels.image_ar')"
                :model="model"
              ></uplode-image-direct>
            </div> -->
            <!-- End:: Image Ar -->

            <!-- Start:: Image Ar -->
            <!-- <div class="col-lg-6">
              <uplode-image-direct
                @inputChanged="uplodeImg_2"
                :placeHolder="$t('forms.labels.image_en')"
                :model="model"
              ></uplode-image-direct>
            </div> -->
            <!-- End:: Image Ar -->

            <!-- Start:: Ar title -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.title"
                />
                <label for="name_input" class="form-label">{{
                  $t("forms.labels.title_ar")
                }}</label>
              </div>
            </div>
            <!-- End:: Ar title -->

            <!-- Start:: En title -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.title"
                />
                <label for="name_input" class="form-label">{{
                  $t("forms.labels.title_en")
                }}</label>
              </div>
            </div>
            <!-- End:: En title -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_ar") }}
                </label>

                <ckeditor v-model="data.ar.desc" />
                <!-- <textarea
                  class="form-control"
                  rows="5"
                  v-model="data.ar.desc"
                ></textarea> -->
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_ar") }}
                </label>

                <ckeditor v-model="data.en.desc" />
                <!-- <textarea
                  class="form-control"
                  rows="5"
                  v-model="data.ar.desc"
                ></textarea> -->
              </div>
            </div>
            <div class="col-lg-12 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.user_type") }}
                </label>
                <multiselect
                  v-model="data.user_type"
                  :options="user_types"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>

            <!-- Start:: Ar slug -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.slug"
                />
                <label for="name_input" class="form-label">{{
                  $t("forms.labels.slug_ar")
                }}</label>
              </div>
            </div> -->
            <!-- End:: Ar title -->

            <!-- Start:: En slug -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.slug"
                />
                <label for="name_input" class="form-label">{{
                  $t("forms.labels.slug_en")
                }}</label>
              </div>
            </div> -->
            <!-- End:: En slug -->

            <!-- Start:: user type -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">نوع المستخدم</label>
                <multiselect
                  v-model="data.user_type"
                  :options="user_types"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div> -->
            <!-- End:: user type -->

            <!-- Start:: En slug -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ordering"
                />
                <label for="name_input" class="form-label">{{
                  $t("forms.labels.ordering")
                }}</label>
              </div>
            </div> -->
            <!-- End:: En slug -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button
            class="button_style_1"
            :class="btnIsLoading ? 'disabled' : ''"
          >
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>

      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      dateMenu: false,
      dateMenu2: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.refund_policy.title"),
          disabled: false,
          href: "/refund-policy",
        },
        {
          text: this.$t("breadcrumb.refund_policy.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      model: "privacies",
      data: {
        ar: {
          image: {
            title: null,
            src: null,
          },
          title: null,
          desc: null,
          slug: null,
        },
        en: {
          image: {
            title: null,
            src: null,
          },
          title: null,
          desc: null,
          slug: null,
        },
        user_type: null,
        ordering: null,
      },
      user_types: [
        {
          id: "driver",
          name: this.$t("driver"),
        },
        {
          id: "client",
          name: this.$t("client"),
        },
        {
          id: "restaurant",
          name: "متجر",
        },
      ],
    };
  },
  // computed: {
  //   user_types() {
  //     return [
  //       {
  //         id: "client",
  //         name: "عميل",
  //       },
  //       {
  //         id: "driver",
  //         name: "سائق",
  //       },
  //     ];
  //   },
  // },
  methods: {
    // Uplode Image
    uplodeImg_1(obj) {
      this.data.ar.image.title = obj;
    },
    // Uplode Image
    uplodeImg_2(obj) {
      this.data.en.image.title = obj;
    },

    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.data.ar.title || !this.data.en.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.title"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ar.desc || !this.data.en.desc) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.desc"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.user_type) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.user_type"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();

      // submit_data.append("ar[image]", this.data.ar.image.title || "");
      // submit_data.append("en[image]", this.data.en.image.title || "");

      submit_data.append("ar[name]", this.data.ar.title || "");
      submit_data.append("en[name]", this.data.en.title || "");

      submit_data.append("ar[description]", this.data.ar.desc || "");
      submit_data.append("en[description]", this.data.en.desc || "");
      submit_data.append("user_type", this.data.user_type.id);
      // submit_data.append("user_type", this.data.user_type.id || "");

      // submit_data.append("ar[slug]", this.data.ar.slug || "");
      // submit_data.append("en[slug]", this.data.en.slug || "");

      // submit_data.append("ordering", this.data.ordering || "");

      this.$axios({
        method: "POST",
        url: "refund_policy",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/refund-policy/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  created() {},
};
</script>
